import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import { OverlayTrigger, OverlayTriggerProps, Tooltip } from 'react-bootstrap';
import { Icon, IconProps } from '../Icon';
import styles from './InfoTooltip.module.scss';

type InfoTooltipProps = {
	content: ReactNode;
	size?: 'md';
	iconName?: IconProps['name'] | false;
	iconSize?: IconProps['size'];
	iconColor?: IconProps['color'];
	tabIndex?: number;
	className?: string;
	trigger?: OverlayTriggerProps['trigger'];
};

export const InfoTooltip: FC<InfoTooltipProps> = ({
	content,
	size,
	iconName = 'InfoCircle',
	iconSize = undefined,
	iconColor,
	tabIndex = 0,
	className,
	children,
	trigger = ['hover', 'focus'],
}) => {
	return (
		<OverlayTrigger
			placement="top"
			flip
			trigger={trigger}
			rootClose
			overlay={(props) => (
				<Tooltip
					{...props}
					placement={props?.popper?.state?.placement || 'top'}
					className={classNames({
						[`tooltip-${size}`]: size,
					})}
				>
					{content}
				</Tooltip>
			)}
		>
			<span className={classNames(styles.infoTooltip, 'infoTooltip', className)} tabIndex={tabIndex}>
				{children && <span>{children}</span>}

				{iconName && <Icon name={iconName} size={iconSize} color={iconColor} className={styles.infoTooltipIcon} />}
			</span>
		</OverlayTrigger>
	);
};
